import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const getAllRoute = async() => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ROUTES, token)
  return res;
};

export const getAllRoutebyContractor = async(tenant_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ROUTES_BY_CONTRACTOR+tenant_id, token)
  return res;
};

export const getRouteDetails = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_ROUTE_DETAILS}/${id}`, token)
  return res;
};

export const addRoute = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_ROUTE, payload, token)
  return res;
};
export const updateRoute = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_ROUTE}/${id}`, payload, token)
  return res;
};
export const deleteRouteByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_ROUTE}/${id}`, {}, token)
  return res;
};
